<template>
    <div class="contact-content">
        <!-- title -->
        <h1 class="main-title">
            <span>
                {{$t('contactUs.title')}}
                <hr>
            </span>
        </h1>

        <!-- form -->
        <div class="row contact-row">
            <div class="col-sm-6 col-l">
                <ValidationObserver ref="form">
                    <form @submit.prevent="onSubmit">
                        <div class="form-group">
                            <div class="col-sm-6">
                                <ValidationProvider :name="$t('contactUs.firstName')" rules="required" v-slot="{ errors }">
                                    <label for="First Name">{{$t('contactUs.firstName')}}<i>*</i></label>
                                    <input class="form-control" :class="{'inwarning':errors[0]}" v-model="firstname" type="text" id="firstname" name="firstName">
                                    <div class="tips">
                                        <span>{{ errors[0]}}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="col-sm-6">
                                <ValidationProvider :name="$t('contactUs.lastName')" rules="required" v-slot="{ errors }">
                                    <label for="Last Name">{{$t('contactUs.lastName')}}<i>*</i></label>
                                    <input class="form-control" :class="{'inwarning':errors[0]}" v-model="lastname" type="text" id="lastname" name="lastName">
                                    <div class="tips">
                                        <span>{{ errors[0]}}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div class="form-group">
                            <ValidationProvider :name="$t('contactUs.email')" :rules="{required:true,email:true}" v-slot="{ errors }">
                                <label for="Email">{{$t('contactUs.email')}}<i>*</i></label>
                                <input class="form-control" :class="{'inwarning':errors[0]}" v-model="email" type="text" id="Email" name="Email">
                                <div class="tips">
                                    <span>{{ errors[0]}}</span>
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="form-group">
                            <ValidationProvider :name="$t('contactUs.message')" rules="required" v-slot="{ errors }">
                                <label for="Message">{{$t('contactUs.message')}}<i>*</i></label>
                                <textarea class="form-control" :class="{'inwarning':errors[0]}" v-model="message" rows="3" type="text" id="Message" name="Message"></textarea>
                                <div class="tips">
                                    <span>{{ errors[0]}}</span>
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="form-group">
                            <ValidationProvider :name="$t('contactUs.additionalDetails')" rules="required" v-slot="{ errors }">
                                <label for="AdditionalDetails">{{$t('contactUs.additionalDetails')}}<i>*</i></label>
                                <textarea class="form-control" :class="{'inwarning':errors[0]}" v-model="additionalDetails" rows="3" type="text" id="AdditionalDetails" name="AdditionalDetails"></textarea>
                                <div class="tips">
                                    <span>{{ errors[0]}}</span>
                                </div>
                            </ValidationProvider>
                        </div>
                        <button class="btn btn-send">{{$t('contactUs.sendMessage')}}</button>
                    </form>
                </ValidationObserver>

                <ul class="contact-mothods">
                    <li v-for="(item,index) in contactInfor[$i18n.locale]" :key="index">
                        <img :src=item.icon alt="">
                        <span>{{item.infor}}</span>
                    </li>
                </ul>
            </div>
            <div class="col-sm-6 col-r">
                <h1>{{$t('contactUs.howHelp')}}</h1>
                <!-- <p>m semper libero, sit amet adipiscing sem neque sed ipsum. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem. Maecenas nec odio et ante tincidunt tempus. Donec vitae sapien ut libero venenatis faucibus. Nullam quis ante. Etiam sit amet </p> -->
                <ul class="col-r-list">
                    <li v-for="(item,index) in colrList[$i18n.locale]" :key="index">
                        <router-link to="/FAQ"><span>{{item.title}}</span></router-link>
                        <i>{{item.tips}}</i>
                    </li>
                </ul>
                
                <div class="col-l-column">
                    <h2>{{$t('contactUs.trustedBy')}}</h2>
                    <ul class="img">
                        <li v-for="(item,index) in columnImg" :key="index" >
                            <img :src="item.url" alt="">
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                firstname:'',
                lastname:'',
                email:'',
                message:'',
                additionalDetails:'',
                contactInfor:{
                    EN:[
                        {
                            icon:require('../../assets/images/64113.png'),
                            infor:"15495 Sand Canyon Rd, Suite 350,Irvine, CA 92618"
                        },
                        {
                            icon:require('../../assets/images/52971-200.png'),
                            infor:"+(1) 949-681-2900"
                        }
                    ],
                    CN:[
                        {
                            icon:require('../../assets/images/64113.png'),
                            infor:"215300 中国江苏省昆山市长江南路出口加工区第二大道269号"
                        },
                        {
                            icon:require('../../assets/images/52971-200.png'),
                            infor:"+(86) 512 5736-7777"
                        }
                    ],
                    CHT:[
                        {
                            icon:require('../../assets/images/64113.png'),
                            infor:"11568 臺北市南港區南港路一段 209 號 A 棟 5 樓"
                        },
                        {
                            icon:require('../../assets/images/52971-200.png'),
                            infor:"+(886) 2 2785-7888"
                        }
                    ],
                    JP:[
                        {
                            icon:require('../../assets/images/64113.png'),
                            infor:"〒600-8146 京都市下京区七条通り东洞院东入る材木町499番地2 第1キョートビル"
                        },
                        {
                            icon:require('../../assets/images/52971-200.png'),
                            infor:"＋(81)75-634-6312"
                        }
                    ]
                },
                colrList:{
                    EN:[
                        {
                            title:"Require a Sample",
                            tips:"Contact us to request a production-quality sample produced by our most advanced technology"
                        },{
                            title:"Get Inspired",
                            tips:"Discover the cutting-edge solutions MPT provides"
                        }
                    ],
                    CN:[
                        {
                            title:"索取样品",
                            tips:"联络我们，以索取我们使用最先进之技术生产的样品"
                        },{
                            title:"获得启发",
                            tips:"探索 MPT 提供之最先进的解决方案"
                        }
                    ],
                    CHT:[
                        {
                            title:"索取樣品",
                            tips:"聯絡我們，以索取我們使用最先進之技術生產的生產品質樣本"
                        },{
                            title:"新的構想",
                            tips:"探索 MPT 提供之最先進的解決方案"
                        }
                    ],
                    JP:[
                        {
                            title:"サンプルを依頼する",
                            tips:"弊社にご連絡いだだければ、最新技術のサンプルをご提供します。"
                        },{
                            title:"知恵が出る",
                            tips:"マイタックテクノロジー京都株式会社は最先進solutionを提供する。"
                        }
                    ]
                },
                columnImg:[
                    {url:require('../../assets/images/ProgressMark_logo.png')},
                    {url:require('../../assets/images/sony_logo_black.png')},
                    {url:require('../../assets/images/Nvidia-logo_black.png')},
                    {url:require('../../assets/images/Dell_logo_black.png')},
                    {url:require('../../assets/images/inter_logo_black.png')}
                ]
            }
        },
        methods:{
            onSubmit () {
                this.$refs.form.validate().then(success => {
                    if (!success) {
                        return;
                    }else{
                        let opt = {
                            "firstname":this.firstname,
                            "lastname":this.lastname,
                            "email":this.email,
                            "message":this.message,
                            "additionalDetails":this.additionalDetails,
                            "site":'MPTK',
                            "language":localStorage.getItem('lang')
                        }
                        this.$api.SendMailAddress.SaveForVisitorInfor(opt).then(res=>{
                            this.$message.success(this.$t('common.sendSuccess'))
                        }).catch(
                            (error) => {
                                this.$message.fail(this.$t('common.sendFail'))
                                console.log(error)
                            }
                        )
                        // Resetting Values
                        this.firstname = this.lastname = this.email = this.message = this.additionalDetails ='';
                        // Wait until the models are updated in the UI
                        this.$nextTick(() => {
                        this.$refs.form.reset();
                        });
                    }
                    
                });
            }
        },
        mounted(){
            console.log(this.$route.path,"222222222222222")
        }
    }
</script>

<style scoped>
    .contact-content{
        margin-bottom: 8rem;
    }
    .contact-row .col-l{
        box-shadow: 2px 2px 25px rgba(0, 0, 0, .15) ;
        padding:4rem;
    }
    .contact-row form label{
        text-align: left;
        display: block;
        font-size: 1.4rem;
        font-weight: normal;
    }
    .contact-row form label i{
        color:#ff0000;
    }
    .contact-row form .form-group{
        overflow: hidden;
        margin-bottom: 1rem;
    }
    .contact-row form .form-group>div{
        padding:0;
        padding-right: 2rem;
    }
    .contact-row form .form-group>div:last-child{
        padding:0;
    }
    .contact-row form .form-group .form-control~div{
        height:2.4rem;
        line-height: 2.4rem;
    }
    .tips span{
        display: block;
        color:#ff0000;
        text-align: left;
    }
    .form-control{
        border-radius: 0;
        box-shadow: none;
        border:1px solid #707070;
        text-align: left;
    }
    .inwarning{
        border:1px solid #ff0000;
    }
    input[type=text].form-control{
        height: 4.8rem;
    }
    textarea[type=text]{
        height:8rem;
    }
    .btn-send{
        width: 100%;
    }
    .contact-mothods{
        margin-top: 4rem;
        padding-top: 4rem;
        border-top: 1px solid #707070;
    }
    .contact-mothods li{
        text-align: left;
        margin-bottom: 2rem;
        display: flex;
        align-items: center;
        flex:1;
    }
    .contact-mothods li span{
        text-align: left;
    }
    .contact-mothods li img{
        max-width: 100%;
        height: auto;
        margin-right: 2rem;
    }
    .col-r{
        padding-left: 4rem;
    }
    .col-r h1{
        font-size: 4.8rem;
        font-weight: 700;
        text-align: left;
        margin-top: 4rem;
        margin-bottom: 8rem;
    }
    .col-r p{
        width: auto;
        text-align: left;
        font-size: 1.4rem;
    }
    .col-r-list a:hover{
        text-decoration: none;
    }
    .col-r-list span{
        display: block;
        background: url(../../assets/images/arrow.png) right center no-repeat;
        background-size: 2rem;
        border-bottom: 1px solid #707070;
        line-height: 4.8rem;
        margin: 2rem 0;
        text-align: left;
        font-size: 2rem;
        font-weight: 700;
    }
    .col-r-list i{
        display: block;
        text-decoration: none;
        text-align: left;
    }
    .col-l-column{
        margin-top: 25rem;
    }
    .col-l-column h2{
        font-size: 1.6rem;
        color:#29AAE1;
        text-align: left;
        margin-bottom: 2rem;
    }
    .col-l-column .img li{
        float: left;
        width:20%;
    }
    .col-l-column .img li img{
        max-width: 100%;
        width:100%;
        height: auto;
    }
    @media (max-width: 767px){
        .contact-content{
            margin-bottom: 4rem;
        }
        .contact-row .col-l{
            padding:1rem;
        }
        .contact-row form label{
            font-size: 0.7rem;
        }
        .contact-row form .form-group>div{
            padding:0;
        }
        .contact-row form .form-group .form-control~div{
            height:1.2rem;
            line-height: 1.2rem;
        }
        input[type=text].form-control{
            height: 2.4rem;
        }
        textarea[type=text]{
            height:8rem;
        }
        .contact-row form .form-group{
            margin-bottom: 0;
        }
        .contact-mothods{
            margin-top: 2rem;
            padding-top: 2rem;
        }
        .col-r{
            padding-left: 0.75rem;
        }
        .col-r h1{
            font-size: 1.2rem;
            margin-top: 2rem;
            margin-bottom: 1rem;
        }
        .col-r p{
            font-size: 0.7rem;
            padding:0;
        }
        .col-r-list span{
            background-size: 1rem;
            line-height: 2.4rem;
            margin: 1rem 0;
            font-size: 1rem;
        }
        .col-l-column{
            margin-top: 2rem;
        }
        .col-l-column h2{
            font-size: .8rem;
            margin-bottom: 1rem;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/ContactUs/ContactUs.vue